import {combineReducers} from 'redux'
import firebaseReducer from './firebaseReducer'
import userReducer from './userReducer'

const appReducer = combineReducers({
  firebaseReducer: firebaseReducer,
  userReducer: userReducer,
})

const rootReducer = (state, action) => {
  if (action.type === 'CLEAR_STORE') {
    state = {
      ...state,
      userReducer: {
        isSignedIn: false,
        testVal: 123,
        isLoading: false,
        theme: 'dark',
        pagesData: {},
        onMFATab: false,
        isModelMenuShowing: true,
        selectedModel: null,
        isVerboseMode: false,
      },
      // firebaseReducer: state.firebaseReducer,
    }
  }
  return appReducer(state, action)
}

export default rootReducer
